<template>
  <div class="highlights-models-container">
    <v-card>
      <div class="models-card-header">
        <h1 class="title mb-8">Modelo do destaque</h1>
      </div>
      <v-radio-group v-model="model" class="models-group d-flex flex-row">
        <div class="expanded-model">
          <div class="radio-section">
            <v-radio key="expanded" :disabled="!isEditable" label="Destaque Expandido" color="primary" value="EXPANDED" />
          </div>
          <mobile-frame height="600px">
            <template v-slot:mobile-content>
              <expanded-model />
            </template>
          </mobile-frame>
        </div>
        <div class="default-model">
          <div class="radio-section"><v-radio key="default" :disabled="!isEditable" label="Destaque Padrão" color="primary" value="DEFAULT" /></div>
          <mobile-frame height="600px">
            <template v-slot:mobile-content>
              <default-model />
            </template>
          </mobile-frame>
        </div>
      </v-radio-group>
    </v-card>
  </div>
</template>
<script>
import { highlightOffer } from '../../../../mixins/highlight-offer'
export default {
  name: 'PickHighlightModel',
  components: {
    MobileFrame: () => import('../MobileFrame.vue'),
    ExpandedModel: () => import('../ExpandedModel.vue'),
    DefaultModel: () => import('../DefaultModel.vue'),
  },
  mixins: [highlightOffer],
  data: () => ({
    modelTypeChange: true,
  }),
  computed: {
    model: {
      get() {
        return this.highlightModelType
      },
      set(value) {
        this.setHighlightKeyValue({ payload: value, key: 'type' })
      },
    },
    isEditable() {
      return ['DRAFT', 'SCHEDULED'].includes(this.highlightStatus)
    },
  },
  watch: {
    model: {
      async handler(newValue, oldValue) {
        if (
          ((newValue !== oldValue && this.highlightTag?.active) || this.highlightBannerImage || this.highlightIconImage || this.highlightDisplayTitle) &&
          this.modelTypeChange &&
          oldValue?.length > 0
        ) {
          const confirmed = await this.$confirm({
            title: 'Mudar o modelo do destaque',
            message: 'Ao mudar o modelo de destaque, você precisará preencher novamente todas as informações no próximo passo.',
            confirmText: 'Confirmar',
            confirmColor: 'primary',
            cancelText: 'Cancelar',
            cancelColor: 'error',
          })
            .then(() => true)
            .catch(() => false)

          if (confirmed) {
            this.setHighlightObject({
              ...this.highlightOffer,
              displayTitle: '',
              bannerImage: '',
              iconImage: '',
              tag: {
                active: false,
                image: '',
              },
            })
            this.model = newValue
            this.modelTypeChange = true
          } else {
            this.model = oldValue
            this.modelTypeChange = false
          }
        } else {
          this.model = newValue
          this.modelTypeChange = true
        }
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.highlights-models-container {
  width: 100%;
  .v-card {
    width: 100%;
    padding: 24px 16px 0 16px;
  }
}
.models-group {
  .expanded-model,
  .default-model {
    width: 420px;
    display: flex;
    justify-content: center !important;
    flex-direction: column;
    align-content: center;
    .radio-section {
      display: flex;
      justify-content: center !important;
      align-content: center;
      margin-bottom: 24px;
    }
  }
}

::v-deep .v-input--radio-group--column .v-input--radio-group__input {
  justify-content: space-between;
  width: 100%;
  display: flex !important;
  flex-direction: row !important;
  padding: 0 10% 0 10%;
}
::v-deep .v-radio {
  justify-content: center;
  .v-messages {
    display: none !important;
  }
}
::v-deep .v-messages {
  display: none !important;
}
::v-deep .v-input__control {
  margin-bottom: -8px !important;
}
</style>
